import axios from 'axios';
import Cookies from 'universal-cookie';

// ── Estado inicial ─────────────────────────────────────────────────────────────
const initialState = {
    entries: [],       // SupervisionEntryDTO[]
    loading: false,
    error: null,
    unassigning: false,
    responseTimes: [], // AgentResponseTimeDTO[]
    loadingTimes: false,
    timesError: null,
};

// ── Action Types ───────────────────────────────────────────────────────────────
const FETCH_START    = 'supervision/FETCH_START';
const FETCH_SUCCESS  = 'supervision/FETCH_SUCCESS';
const FETCH_ERROR    = 'supervision/FETCH_ERROR';
const UNASSIGN_START = 'supervision/UNASSIGN_START';
const UNASSIGN_DONE  = 'supervision/UNASSIGN_DONE';
const TIMES_START    = 'supervision/TIMES_START';
const TIMES_SUCCESS  = 'supervision/TIMES_SUCCESS';
const TIMES_ERROR    = 'supervision/TIMES_ERROR';

// ── Reducer ────────────────────────────────────────────────────────────────────
export default function supervisionReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_START:
            return { ...state, loading: true, error: null };
        case FETCH_SUCCESS:
            return { ...state, loading: false, entries: action.payload };
        case FETCH_ERROR:
            return { ...state, loading: false, error: action.payload };
        case UNASSIGN_START:
            return { ...state, unassigning: true };
        case UNASSIGN_DONE:
            return { ...state, unassigning: false };
        case TIMES_START:
            return { ...state, loadingTimes: true, timesError: null };
        case TIMES_SUCCESS:
            return { ...state, loadingTimes: false, responseTimes: action.payload };
        case TIMES_ERROR:
            return { ...state, loadingTimes: false, timesError: action.payload };
        default:
            return state;
    }
}

// ── Helpers ────────────────────────────────────────────────────────────────────
const getHeaders = () => {
    const cookies = new Cookies();
    return { Authorization: `Bearer ${cookies.get('token')}` };
};

// ── Thunks ─────────────────────────────────────────────────────────────────────

/**
 * Obtiene las entradas del panel de supervisión.
 * Solo incluye asignaciones activas con conversación en control humano.
 */
export const fetchSupervisionEntriesFromAPI = (businessLineId = null) => async (dispatch) => {
    dispatch({ type: FETCH_START });
    try {
        const params = {};
        if (businessLineId !== null) params.businessLineId = businessLineId;

        const res = await axios.get(`${window.API_BASE_URL}/assignments/supervision`, {
            params,
            headers: getHeaders(),
        });

        dispatch({ type: FETCH_SUCCESS, payload: res.data ?? [] });
    } catch (error) {
        console.error('Error fetching supervision entries:', error);
        dispatch({ type: FETCH_ERROR, payload: error?.message ?? 'Error al cargar supervisión' });
    }
};

/**
 * Obtiene los tiempos de demora en responder por consultor en un rango.
 */
export const fetchResponseTimesFromAPI = (from, to, businessLineId = null) => async (dispatch) => {
    dispatch({ type: TIMES_START });
    try {
        const params = { from: from.toISOString(), to: to.toISOString() };
        if (businessLineId !== null) params.businessLineId = businessLineId;

        const res = await axios.get(`${window.API_BASE_URL}/reports/agent-response-times`, {
            params,
            headers: getHeaders(),
        });

        dispatch({ type: TIMES_SUCCESS, payload: res.data ?? [] });
    } catch (error) {
        console.error('Error fetching response times:', error);
        dispatch({ type: TIMES_ERROR, payload: error?.message ?? 'Error al cargar tiempos de respuesta' });
    }
};

/**
 * Libera la asignación de un agente a un cliente.
 */
export const unassignClientInAPI = (clientId, businessLineId) => async (dispatch) => {
    dispatch({ type: UNASSIGN_START });
    try {
        await axios.delete(
            `${window.API_BASE_URL}/assignments/${clientId}/businessLine/${businessLineId}`,
            { headers: getHeaders() }
        );
    } catch (error) {
        console.error('Error unassigning client:', error);
        throw error;
    } finally {
        dispatch({ type: UNASSIGN_DONE });
    }
};
